import React, { useState, useEffect, useRef } from "react";
import { TextInput } from "react-native";
import { useValidation } from "../hooks";
import { backgroundColor, backgroundColor2 } from "../constants/Constants";
import { fullDataPiece } from "../services/ConnectDataBase";
import { translateText } from "../translations/translationService";
import { SCAN_SCREEN_COLORS } from "../style/colors.js";
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
  withSequence,
  withDelay,
} from "react-native-reanimated";
import { styles } from "../style/styles";
import texts from "../translations/texts";
import { useSelector, useDispatch } from "react-redux";
import { updateInfoData } from "../redux/reducers";
import { getArrayInfoDataUpdate } from "../services/Functions";
import { LinearGradient } from "expo-linear-gradient";
import { Box, Typography, Button, Paper } from "@mui/material";
import { notify } from "../services/ui/notify";

export default function ScanScreen({ navigation }) {
  const dispatch = useDispatch();
  const [code, setCodeRaw] = useState("");
  const [hasSuffix, setHasSuffix] = useState(false);
  const inputRef = useRef(null);
  const lang = useSelector((state) => state.lang.value);
  const translateX = useSharedValue(styles.barcode.height - 420);
  const cod_team = useSelector((state) => state.user.cod_team);
  const redLineStyle = useAnimatedStyle(() => ({
    transform: [{ translateY: translateX.value }],
  }));

  // Hook de validación
  const { validateData } = useValidation({
    autoDispatch: true,
    validationType: 2
  });

  const setCode = (codeInput) => {
    if (codeInput.endsWith("-999")) {
      setHasSuffix(true);
      const modifiedCode = codeInput.substring(0, codeInput.length - 4);
      setCodeRaw(modifiedCode);
    } else {
      setHasSuffix(false);
      setCodeRaw(codeInput);
    }
  };

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleSubmitCode();
      setCodeRaw("");
    }, 1000);
    return () => clearTimeout(timer);
  }, [code]);

  useEffect(() => {
    const animation = withSequence(
      withTiming(-50, { duration: 2000 }),
      withDelay(0, withTiming(styles.barcode.height - 410, { duration: 2000 })),
      withDelay(0, withTiming(-120, { duration: 2000 }))
    );
    translateX.value = animation;
  }, []);

  const handleSubmitCode = async () => {
    try {
      const fullData = await validateData(code);
      if (code && fullData && fullData.mo) {
        if (code.replace("'", "-") !== fullData.mo) {
          notify.warn("El código introducido no es correcto.");
        } else {
          navigation.navigate("Info", {
            data: fullData,
            incidencia: hasSuffix,
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <LinearGradient colors={backgroundColor()} style={{ flex: 1 }}>
      <Box display='flex' flexDirection='column' alignItems='center' p={3}>
        <Typography
          variant='h4'
          align='center'
          gutterBottom
          sx={{
            marginBottom: 4,
            marginTop: 4,
            fontFamily: "monospace",
            fontWeight: "bold",
          }}>
          {texts.ScanScreen.text[lang]}
        </Typography>

        <Paper
          elevation={3}
          sx={{
            width: 190,
            height: 190,
            backgroundImage: `url(${require("../assets/facetDataMatrix.png")})`,
            backgroundSize: "cover",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 3,
          }}></Paper>

        <Animated.View style={[styles.redLine, redLineStyle]}></Animated.View>

        <TextInput
          ref={inputRef}
          style={styles.inputLogin}
          onChangeText={setCode}
          value={code}
          autoFocus={true}
        />

        <Box mt={4}>
          <Button
            variant='contained'
            color='primary'
            onClick={() => navigation.navigate("Screen work")}
            sx={{
              paddingY: 1.5,
              paddingX: 4,
              fontSize: 16,
              fontWeight: "bold",
              backgroundColor: backgroundColor2,
              "&:hover": { backgroundColor: SCAN_SCREEN_COLORS.BACKGROUND_HOVER },
            }}>
            {translateText("Multiples MOs", lang)}
          </Button>
        </Box>
      </Box>
    </LinearGradient>
  );
}
